<template>
  <div v-loading.fullscreen.lock="loading">
    <div class="container-fluid whopperco-container">
      <div class="row window-height">

        <div class="col-12 col-md-6 left-bg">
          <div class="inner-left-wrap p-3 p-md-4">
            <div class="text-center mb-3 anim-fade-in" style="animation-delay: 0.1s">
              <img src="/signup-img/whopperco/bk-logo.png" alt="Burger King" class="bk-logo" />
            </div>
            <div class="text-center mb-3 anim-fade-in" style="animation-delay: 0.2s">
              <p class="whopperco-wordmark mb-0">WHOPPERCO</p>
              <p class="whopperco-tagline">Franchise Training Portal</p>
            </div>

            <div class="signin-header anim-slide-up" style="animation-delay: 0.3s">
              <h3 class="mb-0">Request Access <img src="/signup-img/fire.svg" alt="" /></h3>
              <span class="d-block mb-4">For franchise locations not on Docebo SSO.</span>
            </div>

            <form role="form" @submit.prevent="onSubmit" novalidate class="anim-slide-up" style="animation-delay: 0.4s">
              <div class="row">
                <div class="col-12 col-md-6 mb-3">
                  <input id="firstName" v-model="form.firstName" type="text" autocomplete="given-name" placeholder="First name" class="form-control singup-input" />
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <input id="lastName" v-model="form.lastName" type="text" autocomplete="family-name" placeholder="Last name" class="form-control singup-input" />
                </div>
              </div>

              <div class="mb-3">
                <input id="email" v-model="form.email" type="email" autocomplete="email" placeholder="Work email" class="form-control singup-input" />
              </div>

              <div class="row">
                <div class="col-12 col-md-6 mb-3">
                  <input id="employeeId" v-model="form.employeeId" type="text" inputmode="numeric" placeholder="Employee ID" class="form-control singup-input" />
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <input id="storeNumber" v-model="form.storeNumber" type="text" placeholder="Store # (e.g. BK-2241)" class="form-control singup-input" />
                </div>
              </div>

              <div class="mb-3">
                <label class="dob-label">Date of birth (used as initial password)</label>
                <input id="dob" v-model="form.dob" type="date" class="form-control singup-input" />
              </div>

              <div class="d-flex justify-content-center signinbtn mb-3 mt-4">
                <button type="submit" class="btn d-block w-100" :disabled="loading">
                  <span v-if="!loading">Request Access</span>
                  <span v-else>Submitting…</span>
                </button>
              </div>

              <p v-if="error" class="error">{{ error }}</p>
              <p v-if="submitted" class="success">
                Request received. Your franchise GM has been notified — you'll get an email when you can sign in.
              </p>

              <p class="signin-link text-center mb-0 mt-3">
                Already have an account?
                <router-link to="/login" class="font-weight-bold">Sign in</router-link>
              </p>
            </form>

            <div class="text-center mt-3 anim-fade-in" style="animation-delay: 0.7s">
              <img src="/signup-img/whopperco/hot-logo.png" alt="Home of Training" class="hot-logo" />
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 right-bg">
          <div class="inner-right-wrap d-flex flex-column h-100 pt-5 pl-2 pl-md-5 pr-2 pr-md-5">
            <div class="mb-3 anim-fade-in" style="animation-delay: 0.2s">
              <img src="/signup-img/whopperco/hot-logo.png" alt="Home of Training" class="hot-logo-hero" />
            </div>
            <h2 class="text-white mb-2 anim-slide-up" style="animation-delay: 0.3s">
              New franchise. Same platform.
            </h2>
            <p class="text-white mb-4 anim-slide-up" style="animation-delay: 0.45s">
              Most stores log in through Docebo SSO. If yours doesn't yet, request access here — your GM approves and you're in.
            </p>

            <div class="hero-checklist anim-slide-up" style="animation-delay: 0.55s">
              <div class="hero-check-item">⚡ GM approval is usually same-day</div>
              <div class="hero-check-item">🎓 12 BK courses unlock immediately</div>
              <div class="hero-check-item">📱 Works on any phone or tablet</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhopperRegister',
  data() {
    return {
      form: { firstName: '', lastName: '', email: '', employeeId: '', storeNumber: '', dob: '' },
      loading: false, submitted: false, error: ''
    };
  },
  methods: {
    onSubmit() {
      this.error = ''; this.submitted = false;
      const required = ['firstName', 'lastName', 'email', 'employeeId', 'storeNumber', 'dob'];
      const missing = required.find(k => !this.form[k]);
      if (missing) { this.error = 'All fields are required.'; return; }
      this.loading = true;
      setTimeout(() => { this.loading = false; this.submitted = true; }, 900);
    }
  }
};
</script>

<style scoped>
html, body, .window-height { min-height: 100vh; }
.whopperco-container { font-family: "Inter", "Nunito", sans-serif; color: #1e1e1e; }

.left-bg {
  background: #f3f3f3 url("/signup-img/signup_bg1.svg") no-repeat right bottom;
  background-size: contain;
  display: flex; align-items: flex-start; padding-top: 3vh; min-height: 100vh;
}
.inner-left-wrap { width: 100%; max-width: 460px; margin: 0 auto; }

.bk-logo { max-width: 110px; height: auto; }
.whopperco-wordmark { font-size: 22px; font-weight: 800; letter-spacing: 4px; color: #502314; line-height: 1.1; margin: 0; }
.whopperco-tagline { font-size: 12px; font-weight: 600; color: #6b7280; letter-spacing: 1.5px; text-transform: uppercase; margin: 4px 0 0; }

.signin-header h3 { font-size: 32px; font-weight: 700; color: #1e1e1e; line-height: 40px; }
.signin-header h3 img { margin-left: 4px; vertical-align: middle; height: 28px; }
.signin-header span { font-size: 15px; color: #6b7280; }

.dob-label { display: block; font-size: 12px; font-weight: 600; color: #6b7280; margin-bottom: 6px; letter-spacing: 0.3px; }

.singup-input {
  border: 1.5px solid #e5e7eb; border-radius: 10px; padding: 14px 16px;
  font-size: 15px; height: auto; background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.singup-input:focus { outline: none; border-color: #ea2628; box-shadow: 0 0 0 4px rgba(234, 38, 40, 0.1); }

.signinbtn .btn {
  background: linear-gradient(to bottom, #e48e39 0%, #ea2628 100%);
  border: 0; height: clamp(46px, 6vw, 56px); font-size: clamp(17px, 2vw, 20px);
  font-weight: 600; color: #fff; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; gap: 10px;
  letter-spacing: 0.3px; transition: opacity 0.2s, transform 0.15s;
}
.signinbtn .btn:hover { opacity: 0.92; }
.signinbtn .btn:disabled { opacity: 0.6; cursor: not-allowed; }

.signin-link { font-size: 14px; color: #6b7280; }
.signin-link a { color: #ea2628; }
.hot-logo { max-width: 80px; height: auto; opacity: 0.7; }
.error { color: #ea2628; text-align: center; font-size: 13px; margin-top: 12px; }
.success { color: #15803d; text-align: center; font-size: 14px; font-weight: 600; margin-top: 12px; }

.right-bg {
  background:
    radial-gradient(circle at 20% 20%, rgba(255, 209, 92, 0.18) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(0, 0, 0, 0.25) 0%, transparent 60%),
    linear-gradient(135deg, #ea2628 0%, #c01618 100%);
  min-height: 100vh; position: relative; overflow: hidden;
}
.right-bg::before {
  content: ""; position: absolute; top: -120px; right: -120px;
  width: 380px; height: 380px;
  background: radial-gradient(circle, rgba(255, 209, 92, 0.35) 0%, transparent 65%);
  filter: blur(40px); pointer-events: none;
}
.hot-logo-hero { max-width: 220px; height: auto; filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.3)) brightness(0) invert(1); }
.inner-right-wrap { position: relative; z-index: 1; }
.inner-right-wrap h2 { font-size: 38px; font-weight: 800; line-height: 1.1; letter-spacing: -0.5px; }
.inner-right-wrap p { font-size: 17px; max-width: 88%; opacity: 0.92; line-height: 1.45; }

.hero-checklist { display: flex; flex-direction: column; gap: 10px; margin-top: 8px; }
.hero-check-item {
  color: #fff; font-weight: 600; font-size: 15px;
  background: rgba(255, 255, 255, 0.1); padding: 12px 18px;
  border-radius: 10px; backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
@keyframes btnGlow { 0%, 100% { box-shadow: 0 0 0 0 rgba(228, 142, 57, 0); } 50% { box-shadow: 0 0 24px 5px rgba(234, 38, 40, 0.28); } }
.anim-fade-in { opacity: 0; animation: fadeIn 0.6s ease-out forwards; }
.anim-slide-up { opacity: 0; animation: slideUp 0.6s ease-out forwards; }
.signinbtn .btn { animation: btnGlow 2.5s ease-in-out 1s infinite; }

@media (max-width: 768px) {
  .right-bg { padding: 32px 16px; min-height: auto; }
  .inner-right-wrap h2 { font-size: 28px; }
}
</style>
